import { rpcClient } from './clients/rpcClientV2';
import { generateBuyerEmailRpc } from '../../__generated__/chirp/com/hubspot/commerce/ai/rpc/CommerceGenerationService';
import { getProperty } from 'customer-data-objects/objects/ObjectAccessors';

/**
 * Generates AI content for a quote email
 * @param quoteId The ID of the quote
 * @returns Promise with subject, body content, and inferenceId
 */
export const aiGenerateEmailContent = async aiGenerateEmailParams => {
  var _aiGenerateEmailParam, _response$inferenceId;
  const response = await rpcClient.call(generateBuyerEmailRpc, {
    request: {
      quoteId: Number(aiGenerateEmailParams.quoteId),
      to: {
        email: getProperty(aiGenerateEmailParams.toContact, 'email'),
        firstname: getProperty(aiGenerateEmailParams.toContact, 'firstname'),
        lastname: getProperty(aiGenerateEmailParams.toContact, 'lastname')
      },
      from: {
        name: (_aiGenerateEmailParam = aiGenerateEmailParams.fromValue.name) !== null && _aiGenerateEmailParam !== void 0 ? _aiGenerateEmailParam : undefined,
        from: aiGenerateEmailParams.fromValue.email
      }
    },
    // LlmModule can be slow on the backend, we don't want it to time out
    timeout: 20000
  });
  return {
    // Currently, the backend doesn't return a subject, but may later, leaving this
    // as null for now to simplify changes in future if it starts to support subject.
    subject: null,
    body: response.result,
    inferenceId: (_response$inferenceId = response.inferenceId) !== null && _response$inferenceId !== void 0 ? _response$inferenceId : null
  };
};